import { gql } from '@apollo/client';

import { getApolloClient } from './graphql';

export async function login(GRAPHQL: string | undefined, email: string, password: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  return gqlClient.mutate({
    mutation: gql`
      mutation signInV2($email: String!, $password: String!) {
        signInV2(loginInput: { email: $email, password: $password }) {
          id
          fullName
          email
          isPhoneVerified
          isEmailVerified
          jwt
          refreshToken
          createdAt
          updatedAt
          profiles {
            id
            Name
            Email
            PhoneNumber
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsPhoneNumberVerified
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      }
    `,
    variables: { email, password },
  });
}

export async function signInMagicLink(GRAPHQL: string | undefined, email: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  return gqlClient.mutate({
    mutation: gql`
      mutation signInMagicLink($email: String!) {
        signInMagicLink(magicLinkInput: { email: $email }) {
          session
        }
      }
    `,
    variables: { email },
  });
}

export async function validateOTP(GRAPHQL: string | undefined, code: string, email: string, session: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  return gqlClient.mutate({
    mutation: gql`
      mutation respondToChallenge($email: String!, $code: String!, $session: String!) {
        respondToChallenge(challengeResponseInput: { email: $email, code: $code, session: $session }) {
          id
          fullName
          email
          isPhoneVerified
          isEmailVerified
          jwt
          refreshToken
          createdAt
          updatedAt
          profiles {
            id
            Name
            Email
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsPhoneNumberVerified
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      }
    `,
    variables: { code, email, session },
  });
}

export async function signup(
  GRAPHQL: string | undefined,
  fullName: string,
  email: string,
  phone: string,
  password: string,
) {
  const gqlClient = getApolloClient(GRAPHQL);
  return gqlClient.mutate({
    mutation: gql`
      mutation signUpV2($fullName: String!, $email: String!, $phone: String!, $password: String!) {
        signUpV2(signUpInput: { fullName: $fullName, email: $email, phone: $phone, password: $password }) {
          fullName
          email
          phone
          isEmailVerified
          isPhoneVerified
        }
      }
    `,
    variables: {
      fullName: fullName,
      email: email,
      phone: phone,
      password: password,
    },
  });
}

export async function initResetPassword(GRAPHQL: string | undefined, email: string) {
  const gqlClient = getApolloClient(GRAPHQL);

  return gqlClient.mutate({
    mutation: gql`
      mutation forgotPasswordV2($email: String!) {
        forgotPasswordV2(email: $email)
      }
    `,
    variables: {
      email: email,
    },
  });
}

export async function doResetPassword(
  GRAPHQL: string | undefined,
  email: string,
  otp: string,
  newPassword: string,
) {
  const gqlClient = getApolloClient(GRAPHQL);
  return gqlClient.mutate({
    mutation: gql`mutation {
      confirmForgotPasswordV2(forgotPasswordConfirmInput: {
        email: "${email}"
        otp: "${otp}"
        newPassword: "${newPassword}"
      })
    }`,
  });
}

export async function confirmUser(otp: string, email: string) {
  const gqlClient = getApolloClient();
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation confirmUserV2($email: String!, $otp: String!) {
          confirmUserV2(confirmUserInput: { email: $email, otp: $otp }) {
            fullName
            email
            phone
            isEmailVerified
            isPhoneVerified
          }
        }
      `,
      variables: { email: email, otp: otp },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function onboardUser(payload: any) {
  const gqlClient = getApolloClient();
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation onboardUser($OnboardUserInput: OnboardUserInput!) {
          onboardUser(OnboardUserInput: $OnboardUserInput) {
            id
            coreUserId
            Name
            Email
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsPhoneNumberVerified
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
            Headline
            BackgroundColor
            Intro
            SocialLinks
            jwt
          }
        }
      `,
      variables: { OnboardUserInput: payload },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function requestAccountDelete() {
  const gqlClient = getApolloClient();
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation {
          requestAccountDelete
        }
      `,
    });
  }
  return Promise.reject(new Error('Apollo client not available'));
}

export async function revokeAccountDelete() {
  const gqlClient = getApolloClient();
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation {
          revokeAccountDelete
        }
      `,
    });
  }
  return Promise.reject(new Error('Apollo client not available'));
}
